import {
  Button,
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  TextField,
  MenuItem,
  Paper,
  Stack,
  CardContent,
  Chip,
  Divider,
  ChipProps,
  Tooltip,
} from "@mui/material";
import { useStyles } from "../../../theme/appStyles";
import React, { useEffect, useMemo, useState } from "react";
import { CircularProgress, Grid, Box, Typography } from "@mui/material";
import {
  useChangeStatusOrderListSentToManagerMutation,
  useGetAllGetOrderListHistoryQuery,
  useGetOrderListByIdQuery,
  useGetUserInfoOnyQuery,
  useAdminChangeStatusMutation,
  useGetRestaurantQuery,
  useGetOrderListHistoryRecordByIdQuery,
  useGetStoreQuery,
  useGetStoreItemOrderListQuery
} from "../../../Api/attoDeskApi";
import {
  IOrderItemEdit,
  IOrderList,
  IOrderListHistoryRecord,
  IRestaurant,
  IStore,
  IStoreItem,
  IUserAdmin,
  IStoreRefItem
} from "../../../Api/Interface/api.interface";
import { useParams } from "react-router-dom";
import {
  OrderListStatus,
  SizeOfLevelType,
  beforePriceConfiem,
} from "../../../Core/Enum/enum";
import LogoMain from "../../../Images/logo.webp";
import TableViewIcon from "@mui/icons-material/TableView";
import LocalPrintshopSharpIcon from "@mui/icons-material/LocalPrintshopSharp";
import dayjs, { Dayjs } from "dayjs";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import { useNavigate } from "react-router-dom";
import { useNotifier } from "../../../Core/Notifier";
import StatusPopup from "../../../Components/Delete/StatusPopup";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useFormik } from "formik";
import ChecklistRtlRoundedIcon from "@mui/icons-material/ChecklistRtlRounded";
import { FaEdit, FaTrash, FaExchangeAlt } from "react-icons/fa";
import { GrStatusGood } from "react-icons/gr";
import { BiSolidMessageSquareAdd } from "react-icons/bi";
import { IoPricetagsOutline } from "react-icons/io5";

const convertUnit = (unit: number) => {
  switch (unit) {
    case SizeOfLevelType.kg:
      return "kg";
    case SizeOfLevelType.small:
      return "small";
    case SizeOfLevelType.li:
      return "li";
    case SizeOfLevelType.Medium:
      return "Medium";
    case SizeOfLevelType.Bottle:
      return "Bottle";
    case SizeOfLevelType.Each:
      return "Each";
    case SizeOfLevelType.Large:
      return "Large";
    case SizeOfLevelType.case:
      return "Case";
    default:
      return "";
  }
};

const convertStatus = (unit: string): string => {
  switch (unit) {
    case "OrderListCreated":
      return "Order List Created";
    case "SentToManager":
      return "Sent To Manager";
    case "ManagerApproved":
      return "Approved";
    case "UpdatedPrice":
      return "Updated Price";
    // case "ManagerConfirmed":
    //   return "Confirmed";
    case "Processed":
      return "Processed";
    case "Completed":
      return "Completed";
    case "Rejected":
      return "Rejected";
    default:
      return "";
  }
};

const statusColor: Record<string, ChipProps["color"]> = {
  Created: "success",
  Modified: "warning",
  Deleted: "error",
};

const statusIcon = {
  Created: <BiSolidMessageSquareAdd color="green" size={17} />,
  Modified: <FaEdit color="orange" />,
  Deleted: <FaTrash color="red" />,
  ChangedBranch: <FaExchangeAlt color="orange" />,
  ChangedStatus: <GrStatusGood color="blue" />,
  storeChanged: <BiSolidMessageSquareAdd size={17} color="green" />,
  priceChanged: <IoPricetagsOutline size={17} color="red" />,
};

const statusMessage: Record<string, string> = {
  ChangedBranch: "Branch changed",
  ChangedStatus: "Status updated",
};

const Index = () => {
  const classes = useStyles();
  const { showErrorMessage, showMessage } = useNotifier();
  const { id: orderListHistoryId } = useParams<{ id: string }>();
  const [orderList, setOrderList] = useState<IOrderItemEdit[]>([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10000);
  const navigate = useNavigate();
  const [coursingToStatus, setCoursingToStatus] = useState<string | undefined>(
    ""
  );
  const [open, setOpen] = useState(false);
  const [openOrderListDate, setOpenOrderListDate] = useState(false);

  const {
    data: OrderListDate,
    isLoading: OrderListDateIsLoading,
    isError: OrderListDateIsError,
  } = useGetOrderListByIdQuery({
    searchText: "",
    id: String(orderListHistoryId),
  });

  const {
    data: orderListData,
    isLoading: orderListIsLoading,
    isError: orderListIsError,
    refetch: orderListRefetch,
  } = useGetAllGetOrderListHistoryQuery({
    orderId: String(orderListHistoryId),
    searchText: "",
  });

  const {
    data: orderListRecordData,
    isLoading: orderListRecordIsLoading,
    isError: orderListRecordIsError,
    refetch: orderListRecordRefetch,
  } = useGetOrderListHistoryRecordByIdQuery({
    perentTableId: String(orderListHistoryId),
    searchText: "",
  });

  const { data: userData, isLoading: userIsLoading } = useGetUserInfoOnyQuery({
    searchText: "",
  });

  const [newStatus, { isLoading }] = useAdminChangeStatusMutation();

  const { data: restaurantData, isLoading: restauramtIsLoading } =
    useGetRestaurantQuery({
      searchText: "",
      id: "",
    });

  const { data: storeData, isLoading: storeIsLoading } = useGetStoreQuery({
    searchText: "",
  });

  const { data: storeRefData, isLoading: storeRefIsLoading } = useGetStoreItemOrderListQuery({
    searchText: "",
  });

  const orderListHisrotyRecord = useMemo(() => {
    return orderListData?.data as IOrderItemEdit[];
  }, [orderListData?.data]);

  const orderListDate = useMemo(() => {
    return OrderListDate?.data as IOrderList[];
  }, [OrderListDate?.data]);

  const userList = useMemo(() => {
    return userData?.data as IUserAdmin[];
  }, [userData?.data]);

  const restaurantList = useMemo(() => {
    return restaurantData?.data as IRestaurant[];
  }, [restaurantData?.data]);

  const getAllStoreList = useMemo(() => {
    return storeData?.data as IStore[];
  }, [storeData?.data]);

  const getAllStoreRefList = useMemo(() => {
    return storeRefData?.data as IStoreRefItem[];
  }, [storeRefData?.data]);

  const userMap = useMemo(() => {
    const map = new Map();
    userList?.forEach((category) => {
      map.set(category.id, `${category.user_role_name}`);
    });
    return map;
  }, [userList]);

  const storeRefMap = useMemo(() => {
    const map = new Map();
    getAllStoreRefList?.forEach((category) => {
      map.set(category.id, `${category.referenceNo}`);
    });
    return map;
  }, [getAllStoreRefList]);

  const userMap2 = useMemo(() => {
    const map = new Map();
    userList?.forEach((category) => {
      map.set(category.id, `${category.user_role_name}`);
    });
    return map;
  }, [userList]);

  const restaurantMap = useMemo(() => {
    const map = new Map();
    restaurantList?.forEach((category) => {
      map.set(category.id, category.restaurantsName);
    });
    return map;
  }, [restaurantList]);

  const getStoreMap = useMemo(() => {
    const map = new Map();
    getAllStoreList?.forEach((category) => {
      map.set(category.id, category.storeName);
    });
    return map;
  }, [getAllStoreList]);

  const ReDateId =
    orderListDate?.length > 0 ? orderListDate[0].orderListId : null;
  const createBy =
    orderListDate?.length > 0 ? orderListDate[0].created_by : null;
  const createAt =
    orderListDate?.length > 0 ? orderListDate[0].created_at : null;
  const orderListStatus =
    orderListDate?.length > 0 ? orderListDate[0].orderListStatus : null;
  const RestaurantsId =
    orderListDate?.length > 0 ? orderListDate[0].restaurantsId : null;

  const updatedBy =
    orderListDate?.length > 0 ? orderListDate[0].updated_by : null;
  const updatedAt =
    orderListDate?.length > 0 ? orderListDate[0].updated_at : null;
  const handleExportToExcel = () => {
    const getSafeToFixed = (
      value: string | number | null | undefined
    ): string => {
      const numericValue = parseFloat(String(value));
      return !isNaN(numericValue) ? numericValue.toFixed(2) : "";
    };

    const exportData = orderList.map((row, index) => ({
      Items: row.variantName || "",
      Qty: `${row.productTotalUnit} ${convertUnit(row.variantUnit)}`,
      Remark: row.remark || "",
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "OrderList");
    const fileName = `OrderList_${dayjs(createAt).format("YYYY MMM, DD")}.xlsx`;

    XLSX.writeFile(workbook, fileName);
  };

  const handleExportToPDF = () => {
    const getSafeToFixed = (
      value: string | number | null | undefined
    ): string => {
      const numericValue = parseFloat(String(value));
      return !isNaN(numericValue) ? numericValue.toFixed(2) : "";
    };

    const tableData = orderList.map((row, index) => [
      row.variantName || "",
      `${row.productTotalUnit} ${convertUnit(row.variantUnit)}`,
      row.remark || "",
    ]);

    const tableHeaders = [["Items", "Qty", "Remark"]];

    const doc = new jsPDF("l", "mm", "a4");

    const imageUrl = LogoMain;
    const pageWidth = doc.internal.pageSize.width;
    const imgWidth = 50;
    const imgHeight = 12;
    // const imgX = (pageWidth - imgWidth) / 2;
    const imgY = 10;
    const imgX = 10;

    const img = new Image();
    img.src = imageUrl;

    img.onload = () => {
      doc.addImage(img, "PNG", imgX, imgY, imgWidth, imgHeight);
      const textStartY = imgY + imgHeight / 2;

      const centerText = (text: string, y: number) => {
        const textWidth = doc.getTextWidth(text);
        const textX = (pageWidth - textWidth) / 2;
        doc.text(text, textX, y);
      };

      const rightAlignText = (text: string, y: number) => {
        const textWidth = doc.getTextWidth(text);
        const textX = pageWidth - textWidth - 15;
        doc.text(text, textX, y);
      };

      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
      rightAlignText(`Order List :  ${ReDateId}`, textStartY);

      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
      rightAlignText(
        `Create By: ${userMap2.get(createBy) || ""}, ${dayjs(createAt).format(
          "YYYY MMM, DD"
        )}`,
        textStartY + 5
      );

      (doc as any).autoTable({
        head: tableHeaders,
        body: tableData,
        startY: textStartY + 15,
        theme: "grid",
        styles: { fontSize: 8 },
        headStyles: { fillColor: [200, 200, 200] },
        alternateRowStyles: { fillColor: [245, 245, 245] },
      });

      const fileName = `OrderList_${dayjs(createAt).format(
        "YYYY MMM, DD"
      )}.pdf`;

      doc.save(fileName);
    };
  };

  useEffect(() => {
    if (orderListHisrotyRecord) {
      setOrderList(orderListHisrotyRecord);
    }
  }, [orderListHisrotyRecord]);

  const handleOpenStatusPopup = () => {
    setCoursingToStatus(String(orderListHistoryId));
    setOpen(true);
  };

  const handleCloseStatusPopup = () => {
    setCoursingToStatus(undefined);
    setOpen(false);
  };

  const handleOpenDialogGenerate = () => {
    setOpenOrderListDate(true);
  };

  const handleCloseDialogGenerate = () => {
    setOpenOrderListDate(false);
  };

  const formik = useFormik({
    initialValues: {
      id: "",
      status: "ManagerApproved",
    },
    onSubmit: async (values, { resetForm }) => {
      try {
        const temData = {
          id: String(orderListHistoryId),
          status: values.status,
        };

        const addCompanyResponse = await newStatus(temData).unwrap();
        if (!addCompanyResponse.status) {
          showErrorMessage(addCompanyResponse.message);
        } else {
          showMessage(addCompanyResponse.message);
          resetForm();
          setOpenOrderListDate(false);
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });

  const [changeStatus] = useChangeStatusOrderListSentToManagerMutation();

  const handleChangeStatus = async (id: string) => {
    try {
      const response = await changeStatus(id).unwrap();
      if (response.status) {
        showMessage(response.message);
        setOpen(false);
        navigate(`/order/list/view/${orderListHistoryId}`);
      } else {
        showErrorMessage(response.message);
      }
    } catch (error) {
      showErrorMessage("Failed to change status");
    }
  };

  const formValid = useMemo(() => {
    return formik.values.status !== "" && formik.values.status !== undefined;
  }, [formik]);

  const coursings: IOrderListHistoryRecord[] = Array.isArray(
    orderListRecordData?.data
  )
    ? (orderListRecordData?.data as IOrderListHistoryRecord[])
    : [];

  if (orderListIsLoading || OrderListDateIsLoading || restauramtIsLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Grid container spacing={3}>
      <Grid item lg={8} md={6} sm={12} xs={12}>
        <Card className={classes.orderListLeftCardView}>
          <Grid
            container
            justifyContent={"space-between"}
            spacing={5}
            sx={{ padding: 2, borderBottom: 4 }}
            className={classes.orderListLeftHeader}
          >
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              sx={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Grid
                container
                spacing={1}
                justifyContent="flex-end"
                sx={{ display: "flex" }}
              >
                <Grid item>
                  <Button
                    startIcon={<TableViewIcon />}
                    className={classes.ordeListButton}
                    onClick={handleExportToExcel}
                  >
                    Excel
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    startIcon={<LocalPrintshopSharpIcon />}
                    className={classes.ordeListButton}
                    onClick={handleExportToPDF}
                  >
                    pdf
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    startIcon={<CheckCircleOutlineIcon />}
                    className={classes.ordeListConfirmButton}
                    onClick={() => {
                      if (orderListStatus === "OrderListCreated") {
                        handleOpenStatusPopup();
                      } else {
                        handleOpenDialogGenerate();
                      }
                    }}
                  >
                    Confirm
                  </Button>
                </Grid>
                {(orderListStatus === "OrderListCreated" ||
                  orderListStatus === "SentToManager") && (
                  <Grid item>
                    <Button
                      startIcon={<EditSharpIcon />}
                      className={classes.ordeListEditButton}
                      onClick={() => {
                        const path =
                          orderListStatus === "OrderListCreated"
                            ? `/order/list/edit/${orderListHistoryId}`
                            : `/order/list/sentToManager/edit/${orderListHistoryId}`;

                        navigate(path);
                      }}
                    >
                      Edit
                    </Button>
                  </Grid>
                )}
                {orderListStatus === "ManagerApproved" && (
                  <Grid item>
                    <Button
                      startIcon={<ChecklistRtlRoundedIcon />}
                      className={classes.ordeListConfirmButton}
                      onClick={() => {
                        navigate(
                          `/order/list/price/admin/edit/${orderListHistoryId}`
                        );
                      }}
                    >
                      Price Check List
                    </Button>
                  </Grid>
                )}
                {orderListStatus === "UpdatedPrice" && (
                  <Grid item>
                    <Button
                      startIcon={<EditSharpIcon />}
                      className={classes.ordeListEditButton}
                      onClick={() => {
                        navigate(
                          `/order/list/set/price/edit/${orderListHistoryId}`
                        );
                      }}
                    >
                      Edit Price
                    </Button>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>
          <Box
            sx={{
              height: "90vh",
              overflow: "auto",
              padding: "2px",
              "&::-webkit-scrollbar": {
                width: "4px",
              },
              "&::-webkit-scrollbar-track": {
                background: "#eeeeee",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "#eeeeee",
                borderRadius: "10px",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                background: "#eeeeee",
              },
            }}
          >
            <Grid
              container
              spacing={2}
              my={2}
              px={1}
              sx={{ padding: 2 }}
              className={classes.orderListLeftHeader}
            >
              <Grid item lg={4} md={6} sm={6} xs={6} mb={2}>
                <Grid container>
                  <img
                    src={LogoMain}
                    alt="AttoDesk Login"
                    style={{
                      width: "200px",
                      height: "60px",
                      display: "block",
                    }}
                  />
                </Grid>
              </Grid>

              <Grid item lg={8} md={6} sm={6} xs={6} mb={2}>
                <Typography
                  variant="subtitle1"
                  textAlign={"right"}
                  className={classes.OLCardTitle256}
                >
                  Order List : {ReDateId}
                </Typography>
                {coursings.length === 0 ? (
                  <Typography
                    textAlign={"right"}
                    className={classes.OLTypograpyNormal}
                  >
                    {"Created By : "}
                    {userMap.get(createBy) || ""}
                  </Typography>
                ) : (
                  <Typography
                    textAlign={"right"}
                    className={classes.OLTypograpyNormal}
                  >
                    {"Updated By : "}
                    {userMap.get(updatedBy) || ""}
                  </Typography>
                )}
                {coursings.length === 0 ? (
                  <Typography
                    textAlign={"right"}
                    className={classes.OLTypograpyNormal}
                  >
                    {"Created At : "}
                    {dayjs(createAt).format("MMM-D, YYYY hh:mm A") || ""}
                  </Typography>
                ) : (
                  <Typography
                    textAlign={"right"}
                    className={classes.OLTypograpyNormal}
                  >
                    {"Updated At : "}
                    {dayjs(updatedAt).format("MMM-D, YYYY hh:mm A") || ""}
                  </Typography>
                )}
              </Grid>

              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Grid container justifyContent={"space-between"} spacing={2}>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={2}
                    >
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography
                          textAlign={"right"}
                          className={classes.OLLeftHeading}
                        >
                          {convertStatus(orderListStatus || "")}
                        </Typography>
                        <Typography
                          textAlign={"right"}
                          className={classes.OLLeftHeading}
                        >
                          {/* {"Branch : "} */}
                          {restaurantMap.get(RestaurantsId) || ""}
                        </Typography>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <TableContainer>
                          <Table className={classes.table}>
                            <TableHead className={classes.tableHeaderRow}>
                              <TableRow>
                                {/* <TableCell className={classes.tablheader} sx={{width: "5%"}}>
                            <strong>#</strong>
                          </TableCell> */}
                                <TableCell className={classes.oLTablHeader}>
                                  <strong>Items</strong>
                                </TableCell>
                                <TableCell className={classes.oLTablHeader}>
                                  <strong>Qty</strong>
                                </TableCell>
                                <TableCell className={classes.oLTablHeader}>
                                  <strong>Remark</strong>
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {orderListIsLoading ? (
                                <TableRow>
                                  <TableCell colSpan={20} align="center">
                                    <Box
                                      display="flex"
                                      justifyContent="center"
                                      alignItems="center"
                                      height="10vh"
                                    >
                                      <CircularProgress />
                                    </Box>
                                  </TableCell>
                                </TableRow>
                              ) : orderListIsError ? (
                                <TableRow>
                                  <TableCell colSpan={20} align="center">
                                    <Typography className={classes.leftORTypo}>
                                      Some thing went to wrong
                                    </Typography>
                                  </TableCell>
                                </TableRow>
                              ) : orderList.length === 0 ? (
                                <TableRow>
                                  <TableCell colSpan={20} align="center">
                                    <Typography className={classes.leftORTypo}>
                                      No data available
                                    </Typography>
                                  </TableCell>
                                </TableRow>
                              ) : (
                                orderList.map((row: IOrderItemEdit, index) => (
                                  <TableRow
                                    key={index}
                                    className={classes.tableRowHover}
                                    // sx={{
                                    //   backgroundColor: row.isPreviousPaymentPaid
                                    //     ? "#f79aa61c"
                                    //     : "transparent",
                                    // }}
                                  >
                                    {/* <TableCell
                                scope="row"
                                className={classes.tablCell}
                              >
                                {page * rowsPerPage + index + 1}
                              </TableCell> */}
                                    <TableCell
                                      scope="row"
                                      className={classes.tablCell}
                                    >
                                      <Typography
                                        className={classes.leftORTypo}
                                        onClick={() =>
                                          window.open(
                                            `/variant/view/${row.productId}`,
                                            "_blank"
                                          )
                                        }
                                        sx={{
                                          cursor: "pointer",
                                        }}
                                      >
                                        {row.variantName}
                                      </Typography>
                                    </TableCell>
                                    <TableCell
                                      scope="row"
                                      className={classes.tablCell}
                                    >
                                      <Typography
                                        className={classes.leftORTypo}
                                      >
                                        {row.productTotalUnit}{" "}
                                        {convertUnit(row.variantUnit)}
                                      </Typography>
                                    </TableCell>
                                    <TableCell
                                      scope="row"
                                      className={classes.tablCell}
                                    >
                                      <Typography
                                        className={classes.leftORTypo}
                                      >
                                        {row.remark}
                                      </Typography>
                                    </TableCell>
                                  </TableRow>
                                ))
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>

          {coursingToStatus && (
            <StatusPopup
              open={open}
              handleCloseDelete={handleCloseStatusPopup}
              onConfirm={async () => {
                await handleChangeStatus(String(orderListHistoryId).toString());
              }}
              title="Confirm Status Change"
              content={`Are you sure you want to change the status to "Manager Approval Pending"? 
            Once updated, this action cannot be undone. 
            Order ID: ${ReDateId}`}
            />
          )}

          <Dialog
            open={openOrderListDate}
            onClose={handleCloseDialogGenerate}
            sx={{ padding: 5, minWidth: 450 }}
          >
            <Grid className={classes.Dialog}>
              <form onSubmit={formik.handleSubmit}>
                <Grid
                  container
                  justifyContent={"space-between"}
                  spacing={5}
                  sx={{ borderBottom: 2, padding: 2 }}
                  className={classes.titleGrid}
                >
                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    pt={2}
                    alignContent={"center"}
                  >
                    <Typography className={classes.cardTitle}>
                      Confirm Action
                    </Typography>
                  </Grid>
                </Grid>
                <DialogContent>
                  <DialogContentText sx={{ pt: 3 }}>Status</DialogContentText>
                  <Grid container alignItems="center">
                    <Grid item lg={12} md={12} sm={12} xs={12} pt={1}>
                      <TextField
                        select
                        size="small"
                        className={classes.textField}
                        SelectProps={{
                          native: false,
                        }}
                        defaultValue=""
                        InputLabelProps={{ shrink: true }}
                        {...formik.getFieldProps("status")}
                      >
                        <MenuItem value="" disabled>
                          Select some option
                        </MenuItem>

                        {Object.entries(beforePriceConfiem).map(
                          ([key, value], index) => (
                            <MenuItem key={index} value={value}>
                              {convertStatus(key)}
                            </MenuItem>
                          )
                        )}
                      </TextField>
                    </Grid>
                  </Grid>
                </DialogContent>
                <DialogActions>
                  <Button
                    variant="outlined"
                    startIcon={<CloseIcon />}
                    className={classes.addButton}
                    onClick={handleCloseDialogGenerate}
                  >
                    Cancel
                  </Button>
                  <Box m={0.5}></Box>

                  <Button
                    variant="contained"
                    startIcon={<CheckCircleOutlineIcon />}
                    className={classes.addButton}
                    onClick={() => formik.handleSubmit()}
                    disabled={!formValid || isLoading}
                  >
                    Confirm
                  </Button>
                </DialogActions>
              </form>
            </Grid>
          </Dialog>
        </Card>
      </Grid>

      <Grid item lg={4} md={6} sm={12} xs={12}>
        <Grid container spacing={1}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Card className={classes.orderListRightCard2}>
              <Grid
                container
                justifyContent={"space-between"}
                spacing={5}
                sx={{ padding: 2, borderBottom: 4 }}
                className={classes.oLRightHeader}
              >
                <Grid
                  item
                  sx={{ display: "flex", justifyContent: "flex-start" }}
                >
                  <Grid
                    container
                    spacing={1}
                    justifyContent="flex-start"
                    sx={{ display: "flex" }}
                  >
                    <Grid item>
                      <Typography className={classes.orderLsitHeadingTypo}>
                        History
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}></Grid>
            </Card>
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Box
              sx={{
                height: "100vh",
                overflow: "auto",
                padding: "2px",
                "&::-webkit-scrollbar": {
                  width: "4px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#eeeeee",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#eeeeee",
                  borderRadius: "10px",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  background: "#eeeeee",
                },
              }}
            >
              <Stack spacing={2}>
                {coursings.map((order, index) => {
                  if (
                    order.order_list_record.length === 0 &&
                    order.activeStatus === "NoChange"
                  )
                    return null;

                  const isLast = index === coursings.length - 1;
                  const userId = isLast ? order.created_by : order.updated_by;
                  const userName = userMap.get(userId) || "";

                  return (
                    <Card
                      key={order.id}
                      variant="outlined"
                      className={classes.orderListRightCard2}
                    >
                      <CardContent>
                        <Stack spacing={1} mb={2}>
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                          >
                            {/* <FaRegCalendarAlt style={{ color: "#1976d2", fontSize: 18 }} /> */}
                            <Typography variant="h6" fontWeight={600}>
                              {dayjs(order.order_List_created_at).format(
                                "MMM D, YYYY h:mm A"
                              )}
                            </Typography>
                          </Stack>

                          <Stack
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                            spacing={1}
                            flexWrap="wrap"
                          >
                            <Typography
                              variant="body2"
                              // className={classes.orderLsitHeadingTypoColor}
                              className={`${
                                classes.orderLsitHeadingTypoColor
                              } ${
                                order.activeStatus === "ChangedBranch"
                                  ? classes.changedBranchColor
                                  : ""
                              }`}
                            >
                              {restaurantMap.get(order.restaurantsId) || ""}
                            </Typography>

                            <Typography
                              variant="body2"
                              className={classes.orderLsitHeadingTypoColor}
                            >
                              |
                            </Typography>

                            <Typography
                              variant="body2"
                              // className={classes.orderLsitHeadingTypoColor}
                              className={`${
                                classes.orderLsitHeadingTypoColor
                              } ${
                                order.activeStatus === "ChangedStatus"
                                  ? classes.changedStatusColor
                                  : ""
                              }`}
                            >
                              {convertStatus(order.orderListStatus || "") || ""}
                            </Typography>

                            <Typography
                              variant="body2"
                              className={classes.orderLsitHeadingTypoColor}
                            >
                              |
                            </Typography>

                            <Typography
                              variant="body2"
                              className={classes.orderLsitHeadingTypoColor}
                            >
                              {userName}
                            </Typography>
                          </Stack>
                        </Stack>
                        {order.activeStatus !== "NoChange" && (
                          <>
                            {/* <Divider sx={{ mb: 2 }} /> */}
                            <Stack spacing={1} mb={2}>
                              <Stack
                                direction="row"
                                justifyContent="center"
                                alignItems="center"
                                spacing={1}
                                flexWrap="wrap"
                              >
                                {
                                  statusIcon[
                                    order.activeStatus as keyof typeof statusIcon
                                  ]
                                }

                                <Typography
                                  fontWeight={600}
                                  className={classes.rightORTypoColor}
                                >
                                  <strong>
                                    {statusMessage[
                                      order.activeStatus as keyof typeof statusMessage
                                    ] || "Unknown status"}
                                  </strong>
                                </Typography>
                              </Stack>
                            </Stack>
                          </>
                        )}
                        {order.order_list_record.length > 0 && (
                          <Divider sx={{ mb: 2 }} />
                        )}
                        {order.orderListStatus === "UpdatedPrice" ||
                        order.orderListStatus === "Processed"
                          ? // Group by storeId
                            Object.entries(
                              order.order_list_record.reduce((acc, item) => {
                                const key = item.storeId || "unknown";
                                if (!acc[key]) acc[key] = [];
                                acc[key].push(item);
                                return acc;
                              }, {} as Record<string, typeof order.order_list_record>)
                            ).map(([storeId, items]) => {
                              const storeTotal = items.reduce((sum, i) => {
                                return sum + (Number(i.productTotalPrice) || 0);
                              }, 0);

                              return (
                                <Box key={storeId} mb={3}>
                                  {storeId !== "unknown" && (
                                    <Stack
                                      direction="row"
                                      alignItems="center"
                                      justifyContent="space-between"
                                      sx={{ mb: 1 }}
                                    >
                                      <Typography variant="h5" color="primary">
                                        🏠{" "}
                                        {getStoreMap.get(Number(storeId)) ||
                                          "Unknown Store"}
                                      </Typography>
                                    </Stack>
                                  )}

                                  {items.map((item) => (
                                    <Box key={item.id} mb={2} ml={2}>
                                      <Stack
                                        direction="row"
                                        alignItems="center"
                                        justifyContent="space-between"
                                      >
                                        {item.variantName.length > 20 ? (
                                          <Tooltip
                                            title={
                                              <Typography
                                                variant="body2"
                                                sx={{ whiteSpace: "pre-line" }}
                                              >
                                                <strong>
                                                  {item.variantName}
                                                </strong>
                                              </Typography>
                                            }
                                          >
                                            <Stack
                                              direction="row"
                                              alignItems="center"
                                              spacing={1}
                                            >
                                              {
                                                statusIcon[
                                                  item.activeStatus as keyof typeof statusIcon
                                                ]
                                              }
                                              <Typography
                                                fontWeight={600}
                                                className={
                                                  classes.rightORTypoColor
                                                }
                                                onClick={() =>
                                                  window.open(
                                                    `/variant/view/${item.productId}`,
                                                    "_blank"
                                                  )
                                                }
                                                sx={{
                                                  cursor: "pointer",
                                                }}
                                              >
                                                {`${item.variantName.slice(
                                                  0,
                                                  20
                                                )}...`}
                                              </Typography>
                                            </Stack>
                                          </Tooltip>
                                        ) : (
                                          <Stack
                                            direction="row"
                                            alignItems="center"
                                            spacing={1}
                                          >
                                            {
                                              statusIcon[
                                                item.activeStatus as keyof typeof statusIcon
                                              ]
                                            }
                                            <Typography
                                              fontWeight={600}
                                              className={
                                                classes.rightORTypoColor
                                              }
                                              onClick={() =>
                                                window.open(
                                                  `/variant/view/${item.productId}`,
                                                  "_blank"
                                                )
                                              }
                                              sx={{
                                                cursor: "pointer",
                                              }}
                                            >
                                              {item.variantName}
                                            </Typography>
                                          </Stack>
                                        )}

                                        <Typography
                                          sx={{
                                            fontWeight: "bold",
                                            flex: 1,
                                            textAlign: "right",
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            gap: "4px",
                                            flexWrap: "wrap",
                                          }}
                                        >
                                          <Box
                                            component="span"
                                            color={
                                              item.activeStatus ===
                                              "priceChanged"
                                                ? "red"
                                                : "#28a745"
                                            }
                                          >
                                            {item.productUnitPrice
                                              ? `$${Number(
                                                  item.productUnitPrice
                                                ).toLocaleString()}`
                                              : "N/A"}
                                          </Box>
                                          <Box component="span" color="#28a745">
                                            * {item.productTotalUnit}
                                          </Box>
                                          <Box component="span" color="#28a745">
                                            {convertUnit(item.variantUnit)}
                                          </Box>
                                          <Box component="span">=</Box>
                                          <Box component="span">
                                            {item.productTotalPrice
                                              ? `$${Number(
                                                  item.productTotalPrice
                                                ).toLocaleString()}`
                                              : "N/A"}
                                          </Box>
                                        </Typography>
                                      </Stack>
                                    </Box>
                                  ))}
                                  {/* {storeId !== "unknown" && (
                                    <Stack
                                      direction="row"
                                      alignItems="right"
                                      justifyContent="right"
                                      sx={{ mb: 1 }}
                                    >
                                      <Typography
                                        variant="h5"
                                        color="primary"
                                        textAlign={"right"}
                                      >
                                        Total: ${storeTotal.toFixed(2)}
                                      </Typography>
                                    </Stack>
                                  )} */}
                                </Box>
                              );
                            })
                          : // Render normally (no price or grouping)
                            order.order_list_record.map((item) => (
                              <Box key={item.id} mb={2}>
                                <Stack
                                  direction="row"
                                  alignItems="center"
                                  justifyContent="space-between"
                                >
                                  {item.variantName.length > 20 ? (
                                    <Tooltip
                                      title={
                                        <Typography
                                          variant="body2"
                                          sx={{ whiteSpace: "pre-line" }}
                                        >
                                          <strong>{item.variantName}</strong>
                                        </Typography>
                                      }
                                    >
                                      <Stack
                                        direction="row"
                                        alignItems="center"
                                        spacing={1}
                                      >
                                        {
                                          statusIcon[
                                            item.activeStatus as keyof typeof statusIcon
                                          ]
                                        }
                                        <Typography
                                          fontWeight={600}
                                          className={classes.rightORTypoColor}
                                          onClick={() =>
                                            window.open(
                                              `/variant/view/${item.productId}`,
                                              "_blank"
                                            )
                                          }
                                          sx={{
                                            cursor: "pointer",
                                          }}
                                        >
                                          {`${item.variantName.slice(
                                            0,
                                            20
                                          )}...`}
                                        </Typography>
                                      </Stack>
                                    </Tooltip>
                                  ) : (
                                    <Stack
                                      direction="row"
                                      alignItems="center"
                                      spacing={1}
                                    >
                                      {
                                        statusIcon[
                                          item.activeStatus as keyof typeof statusIcon
                                        ]
                                      }
                                      <Typography
                                        fontWeight={600}
                                        className={classes.rightORTypoColor}
                                        onClick={() =>
                                          window.open(
                                            `/variant/view/${item.productId}`,
                                            "_blank"
                                          )
                                        }
                                        sx={{
                                          cursor: "pointer",
                                        }}
                                      >
                                        {item.variantName}
                                      </Typography>
                                    </Stack>
                                  )}

                                  <Typography
                                    variant="body2"
                                    color="text.secondary"
                                  >
                                    {item.productTotalUnit}{" "}
                                    {convertUnit(item.variantUnit)}
                                  </Typography>
                                </Stack>

                                {item.remark && item.remark.length > 100 ? (
                                  <Tooltip
                                    title={
                                      <Typography
                                        variant="body2"
                                        sx={{ whiteSpace: "pre-line" }}
                                      >
                                        <strong>💬 {item.remark}</strong>
                                      </Typography>
                                    }
                                  >
                                    <Typography
                                      variant="body2"
                                      color="text.secondary"
                                      sx={{ mt: 0.5, pl: 4 }}
                                    >
                                      💬 {`${item.remark.slice(0, 100)}...`}
                                    </Typography>
                                  </Tooltip>
                                ) : (
                                  item.remark && (
                                    <Typography
                                      variant="body2"
                                      color="text.secondary"
                                      sx={{ mt: 0.5, pl: 4 }}
                                    >
                                      💬 {item.remark}
                                    </Typography>
                                  )
                                )}
                              </Box>
                            ))}
                      </CardContent>
                    </Card>
                  );
                })}
              </Stack>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Index;
